import React, { useState, useEffect } from "react";
import KFSModal from "../../UIElements/KFSModal";
import OTPModal from "../../UIElements/OTPModal";
import FormButtonStyle4 from "../../UIElements/FormButton";
import { Document, Page, pdfjs } from "react-pdf";

import Header from "../Header/header";
import { useSelector } from "react-redux";
import callApi from "../../../../utility/apiCaller";
import CustomCheckbox from "../customCheckBox/customCheckBox";
import PDFViewer from "./PdfViewer";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function formatToDDMMYYYY(isoString) {
  const date = new Date(isoString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
}

// Function to download PDF from URL
const downloadPDF = async (url, filename = "document.pdf") => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch PDF");
    }

    const blob = await response.blob(); // convert response to blob
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    // Clean up
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

// 📌 External function for API call
async function updateLead(leadId, token) {
  try {
    await callApi(
      `v1/lead/${leadId}/update-lead-new`,
      "post",
      {
        lead: {
          is_loan_review_completed: true,
          steps_completed: 14,
        },
      },
      "core",
      token ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks"
    );
    console.log("✅ Lead updated successfully");
  } catch (err) {
    console.error("❌ Failed to update lead", err);
  }
}

const LoanReviewPage2 = ({ setCurrentStep }) => {
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const userData = useSelector((state) => state?.aa?.userData);
  const OpportunityName = useSelector((state) => state?.aa?.OpportunityName);
  const user = useSelector((state) => state.app.user);
  //console.log("user", user);
  const aaSlice = useSelector((state) => state?.aa);
  //console.log(aaSlice);
  const appId = aaSlice?.appId;
  const client_leadId = aaSlice?.leadId;
  const responseId = aaSlice?.responseId;
  const kfsUrlFromStore = aaSlice?.kfsUrl;


  useEffect(()=>{
    console.log("kfs Url: ",kfsUrlFromStore)
  },[kfsUrlFromStore])

  


  const lead_Id = aaSlice?.internalLeadId;

  let url = window.location.href;
  const cleanUrl = url.replace("?", "&");
  const params = new URL(cleanUrl).searchParams;
  const oppname = params.get("oppname");

  const loanAmount = 500000;
  const processingFees = 19750;

  const kfsData = [
    { label: "Transaction ID", value: oppname },
    { label: "Full Name", value: userData.contact_name },
    {
      label: "Date of Birth (dd-mm-yyyy)",
      value: formatToDDMMYYYY(userData.dob),
    },
    { label: "Gender", value: userData.gender },
    { label: "Marital Status", value: "" },
    {
      label: "Date (dd-mm-yyyy)",
      value: formatToDDMMYYYY(new Date().toISOString()),
    },
    { label: "Mobile Number", value: userData.contact_phone },
    { label: "Personal E-mail", value: userData.contact_email },
    { label: "Landline Number", value: userData.contact_landline || "" },
  ];

  return (
    <div className="font-atkinson h-[100dvh] w-full max-w-[400px] flex flex-col px-4 py-2">
      <Header />

      {/* 
      <KFSModal
        isOpen={showKFS}
        onClose={() => setShowKFS(false)}
        details={kfsData}
        onContinue={async () => {
          await updateLead(lead_Id, user?.token);
          setCurrentStep((prev) => prev + 1);
        }}
        onSubmit={() => {
          setCurrentStep((prev) => prev + 1);
        }}
      /> 
      */}

      <div className="flex flex-col  mt-auto pb-3">
        {/* PDF Viewer */}
        {/* <div
          className="flex-1 overflow-auto border my-2 flex flex-col items-center"
          style={{ maxHeight: "60dvh" }} // 50% of viewport
        >
          <Document
            file={kfsUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            renderMode="canvas" // ensures proper canvas rendering
          >
            {numPages &&
              Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={index}
                  pageNumber={index + 1}
                  width={350} // Adjust for mobile
                  className="mb-2"
                />
              ))}
          </Document>
        </div> */}

        <PDFViewer kfsUrl={kfsUrlFromStore} />

        {/* Download KFS Button */}
        <a
          href={kfsUrlFromStore}
          download
          onClick={() => {
            downloadPDF(kfsUrlFromStore, "KFS_Document.pdf");
          }}
          target="_blank"
          rel="noopener noreferrer"
          className=" hidden sm:block bg-gradient-to-r from-[#12F280] to-[#1B1B1B] text-white text-center py-2 px-4 rounded mt-2 mb-3 hover:bg-blue-700 transition"
        >
          Download KFS Document
        </a>


        <button
          onClick={() => downloadPDF(kfsUrlFromStore, "KFS_Document.pdf")}
          className="block sm:hidden bg-gradient-to-r from-[#12F280] to-[#1B1B1B] text-white text-sm text-center py-2 px-4 rounded mt-2 w-full max-w-[400px] mx-auto hover:opacity-90 transition"
        >
          Download KFS Document
        </button>

        {/* Terms and Conditions */}
        <div className="flex gap-2 mt-2  px-1 py-3">
          <CustomCheckbox
            checked={isConsentChecked}
            setchecked={setIsConsentChecked}
          />
          <label className="text-sm text-gray-700">
            I agree to have read, accept & electronically sign the terms of
            Sanction letter and terms & Conditions
          </label>
        </div>

        {/* Action Button */}
        <FormButtonStyle4
          text="GET OTP TO SIGN AGREEMENTS"
          onClick={() => {
            updateLead(lead_Id, user?.token);
            setCurrentStep((prev) => prev + 1);
          }}
          disabled={!isConsentChecked}
        />
      </div>

      {/*
      <OTPModal
        isOpen={showOTP}
        onClose={() => setShowOTP(false)}
        onSubmit={() => {
          setCurrentStep((prev) => prev + 1);
        }}
      />
      */}
    </div>
  );
};

export default LoanReviewPage2;
